import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { StyledButton } from '../../Exams/styled';
import { DataGrid } from '@mui/x-data-grid';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { fontSizes } from '../../../layouts/fontSizes';
import { DateWiseConcession } from '../types';
import { getDateWiseConcessionColumns } from '../utils/DateWiseConcessionColumns';
import { DateWiseConcessionTitleWrapper } from '../styled';
import DateWiseConcessionModal from './DateWiseConcessionModal';
import ConfirmationDialog from '../../../components/ConfirmationDialog/ConfirmationDialog';
import tableColumnUtils from '../../../utils/tableColumnUtils';

interface DateWiseConcessionTableProps {
  dateWiseConcession: DateWiseConcession[];
  concessionType: string;
  setDateWiseConcession: React.Dispatch<
    React.SetStateAction<DateWiseConcession[]>
  >;
}

const DateWiseConcessionTable = ({
  dateWiseConcession,
  concessionType,
  setDateWiseConcession
}: DateWiseConcessionTableProps) => {
  const [
    isAddDateWiseConcessionModalOpen,
    setIsAddDateWiseConcessionModalOpen
  ] = useState(false);
  const [dateWiseConcessionModalType, setDateWiseConcessionModalType] =
    useState('');
  const [selectedDateWiseConcession, setSelectedDateWiseConcession] =
    useState<DateWiseConcession>();
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] =
    useState(false);
  const [remainingConcessionAfterDelete, setRemainingConcessionAfterDelete] =
    useState<DateWiseConcession[]>([]);

  const handleDateWiseConcessionDelete = (row: DateWiseConcession) => {
    const remainingConcessionAfterDelete = dateWiseConcession.filter(
      (concession) => concession.id !== row.id
    );
    setRemainingConcessionAfterDelete(remainingConcessionAfterDelete);
    setIsConfirmationDialogOpen(true);
  };

  const handleDateWiseConcessionEdit = (row: DateWiseConcession) => {
    setDateWiseConcessionModalType('edit');
    setIsAddDateWiseConcessionModalOpen(true);
    setSelectedDateWiseConcession(row);
  };

  const handleAddDateWiseConcession = () => {
    setSelectedDateWiseConcession(undefined);
    setDateWiseConcessionModalType('add');
    setIsAddDateWiseConcessionModalOpen(true);
  };

  const handleAddDateWiseConcessionModalClose = () => {
    setIsAddDateWiseConcessionModalOpen(false);
    setSelectedDateWiseConcession(undefined);
  };

  const handleOnDialogConfirm = () => {
    setDateWiseConcession(remainingConcessionAfterDelete);
    setRemainingConcessionAfterDelete([]);
    setIsConfirmationDialogOpen(false);
  };

  const dateWiseConcessionColumns = getDateWiseConcessionColumns(
    concessionType,
    handleDateWiseConcessionEdit,
    handleDateWiseConcessionDelete
  );
  return (
    <>
      <DateWiseConcessionTitleWrapper>
        <Typography
          fontSize={`${fontSizes.placeHolder} !important`}
          fontWeight='bold'
        >
          Date Wise Concession
        </Typography>
        <StyledButton onClick={handleAddDateWiseConcession}>
          Add Date Wise Concession
        </StyledButton>
      </DateWiseConcessionTitleWrapper>
      <DataGrid
        rows={dateWiseConcession}
        columns={dateWiseConcessionColumns}
        disableRowSelectionOnClick
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        sx={dataGridSx(pallet)}
      />
      <DateWiseConcessionModal
        modalType={dateWiseConcessionModalType}
        dateWiseConcessionType={concessionType}
        isAddDateWiseConcessionModalOpen={isAddDateWiseConcessionModalOpen}
        selectedDateWiseConcession={selectedDateWiseConcession}
        onModalClose={handleAddDateWiseConcessionModalClose}
        setDateWiseConcession={setDateWiseConcession}
      />
      <ConfirmationDialog
        message={
          'Are you sure you want to delete the selected Date wise concession mapping?'
        }
        onClose={() => setIsConfirmationDialogOpen(false)}
        onConfirm={handleOnDialogConfirm}
        open={isConfirmationDialogOpen}
      />
    </>
  );
};

export default DateWiseConcessionTable;
